import { css } from '@emotion/react';
import { colors } from '../../../theme/colors';

export const overlayContainer = css`
  display: grid;
  gap: 1rem;
`;

export const overlayed = css`
  grid-column: 1;
  grid-row: 1;
`;

export const editOverlay = css`
  ${overlayContainer};
  margin-block: 1rem;
  padding: 4rem 3rem;
  background: inherit;
  transition: all 0.5s;
  transform-origin: top left;
  transform: scale(0.5);
  width: 200%;
  height: 200%;

  &:hover {
    background: ${colors.primary[10]}88;
  }
  & fieldset {
    ${overlayed};
  }
  &:hover .edit-display-button {
    opacity: 1;
  }
`;

export const editButton = css`
  ${overlayed};
  justify-self: center;
  align-self: center;
  transform: scale(150%);
  opacity: 0;
  transition: all 0.5s;
`;

export const sectionTitle = css`
  ${overlayed};
  transform: translate(0, -3rem);
  font-size: 160%;
`;

export const panelConfigContainer = css`
  padding-block: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, 24rem);
  grid-template-rows: 16rem 16rem;
  align-content: start;
  align-items: start;
  justify-content: start;
`;
